export default __webpack_public_path__ + "static/media/promo_04.0ff06236.jpg";